(function (app, ng) {

    app.config([
        "$stateProvider", function ($stateProvider) {
            $stateProvider.state("Home.Settings.Agency.Users",
                {
                    url: "/Users",
                    component: "users",
                    data: {
                        pageTitle: "Users"
                    }
                });
        }
    ]);

    app.component("users",
        {
            templateUrl: "/App/Settings/Agency/Users/users-template.html",
            controller: usersController,
            bindings: {
                currentUser: "="
            }
        });

    usersController.$inject = ["_", "$state", "userApi", "$mdDialog", "userRegistrationApi", "tenantUserCapacityApi"];
    function usersController(_, $state, userApi, $mdDialog, userRegistrationApi, tenantUserCapacityApi) {
        var $ctrl = this;

        ng.extend($ctrl,
            {
                ui: {
                    loading: true
                },
                order: false,
                orderBy: "LastName",
                viewUser: viewUser,
                usersLimit: 20,
                openAddUser: openAddUser,
                resendRegistration: resendRegistration,
                deleteRegistration: deleteRegistration
            });

        function resendRegistration(registrationId, $event) {
            $ctrl.resending = true;
            userRegistrationApi.resendUserRegistration(registrationId).then(function () {
                $ctrl.resending = false;
                var alert = $mdDialog.alert({
                    focusOnOpen: false,
                    theme: "",
                    title: "User Registration Resent",
                    targetEvent: $event,
                    ariaLabel: "User registration resent",
                    ok: "Ok",
                    multiple: true,
                    clickOutsideToClose: false
                });
                $mdDialog.show(alert);
            });
        }

        function deleteRegistration(registrationId) {
            userRegistrationApi.deleteUserRegistration(registrationId).then(function () {
                $state.reload();
            });
        }

        function openAddUser($event) {
            var alert = $mdDialog.alert({
                focusOnOpen: false,
                templateUrl: "/App/Settings/Agency/AddUser/adduser-template.html",
                controller: "addUserController",
                targetEvent: $event,
                clickOutsideToClose: true
            });

            $mdDialog.show(alert).then(function (user) {
                if (user)
                    $state.go("Home.Settings.Agency.Users", {}, { reload: true });
            });
        }

        function viewUser(user) {
            $ctrl.ui.loading = true;
            $state.go("Home.Settings.Agency.User.Personal", { userId: user.Id });            
        }

        $ctrl.$onInit = () => {
            $ctrl.ui.loadingUsers = true;

            userApi.getUsers().then(function (users) {
                $ctrl.inactiveUsers = _.filter(users,
                    function(user) {
                        return !user.IsActive;
                    });

                userRegistrationApi.getAllIncompleteUserRegistrations().then(function(registrations) {
                    $ctrl.users = users.concat(registrations);

                    tenantUserCapacityApi.getAll().then(function(capacities) {
                        var today = new Date();
                        $ctrl.totalCapacity = 0;
                        $ctrl.userSlots = [];

                        ng.forEach(capacities,
                            function(capacity) {
                                if (today < new Date(capacity.ExpirationDate))
                                    $ctrl.totalCapacity += capacity.UserCapacity;
                            });

                        if ($ctrl.totalCapacity + $ctrl.inactiveUsers.length >= $ctrl.users.length)
                            $ctrl.userSlots = new Array($ctrl.totalCapacity +
                                $ctrl.inactiveUsers.length -
                                $ctrl.users.length);

                        $ctrl.ui.loadingUsers = false;
                    });
                });
            });
        }

        $ctrl.ui.loading = false;
    }
})(window.app, window.angular); //jshint ignore:line